__turbopack_context__.v({
  "button": "style-module-scss-module__cTRL_G__button",
  "close-container": "style-module-scss-module__cTRL_G__close-container",
  "column": "style-module-scss-module__cTRL_G__column",
  "component": "style-module-scss-module__cTRL_G__component",
  "heading": "style-module-scss-module__cTRL_G__heading",
  "image-wrapper": "style-module-scss-module__cTRL_G__image-wrapper",
  "location": "style-module-scss-module__cTRL_G__location",
  "three-columns": "style-module-scss-module__cTRL_G__three-columns",
});
